export const CHECKLIST = [
  'Reading your evaluation result',
  'Applying your transfer block',
  'Matching transferred courses to requirements',
  'Filling outstanding requirement slots',
  'Finalizing your degree plan',
];

export const STEP_MS = 500;
